<template class="fondo">
  <div class="loader" v-if="this.isLoading">
    <img class="rounded mx-auto d-block" src="@/assets/loading.gif" />
  </div>
  <div class="contenedor fondo">
    <div class="d-flex contimg">
      <img src="@/assets/img2.png" class="imagens">
    </div>
    <div class="d-flex contimg2">
      <img src="@/assets/img1.png" class="imagens2">
      <div class="texto-derecha texto-derecha-mobile">
        <label>SI ERES SOCIO ENJOY CLUB</label>
        <div class="curadradoRojo">
          <label>JUEGA Y GANA UNO DE LOS</label><br>
          <label class="masFont">2.000</label><br>
          <label>VIAJES EN CRUCEROS</label><br>
        </div>
        <label>¡TÚ ELIGES EL DESTINO!</label>
      </div>
  </div>

  
  <div class="texto-center">
    <span class="texto-bold textMobile">{{nombre}}</span>
  </div>
    
  <div class="texto-center">
    <span class="texto-bold textMobile">YA TE ENCUENTRAS REGISTRAD@ EN LA PROMOCIÓN</span>
  </div>

  <div class="texto-center" >
    <img src="@/assets/img9.png" class="imagens2" style="width: 250px">  
  </div>

  <div class="texto-center">
    <button class="form-rounded align-self-stretch btn-inscribir-nuevo btn-ver" v-on:click="validaCampo()" :disabled="isLoading" style="width: 40%; padding: 1%;">
      <span>¡REVISA AQUÍ TU AVANCE!</span>
    </button>  </div>

    <div class="texto-center">
      <p class="texto-white">Revisa las <a href="https://www.enjoy.cl/cruceros/bases.pdf" target="_blank" style="color: white;">bases y condiciones aquí</a>.</p>
  </div>
</div>

<div class="row justify-content-center">
    <div class="col-md-12">
      <img src="@/assets/img3.png" alt="Imagen 1" style="width: 100%;">
    </div>
  </div>


  <!--<div v-if="true" class="footer heightFooter">
    <img src="@/assets/logoenjoy.png" alt="">
  </div>-->
</template>


<script>
import useValidate from '@vuelidate/core'
import axios from "axios";
import variables from '@/static/endPoint.json'
import { required, email, minLength, numeric, minValue,} from '@vuelidate/validators'

export default {
  name: 'Registrado',
  data() {
        return {
            isLoading:false,
            variables:variables
        }
    },
  computed:{
    data(){
      return this.$store.state.data.data;
    },
    nombre(){
        return this.$store.state.nombre
    },
    idCliente(){
        return this.$store.state.idCliente;
    },
  },
  methods:{
      validaCampo(){
        this.isLoading=true;
        axios
        .get(this.variables.getValidar + this.idCliente)
          .then((data)=>{
              this.$store.commit('SET_DATA',data);
              console.log(data);
              this.$store.commit('SET_MOSTRAR_YA_REGISTRADO',false);
                  this.$store.commit('SET_MOSTRAR_AVANCE',true);

          })
          .catch((error) => {
            console.log(error.response.data)
            this.$store.commit('SET_ID_CLIENTE',dni);

            this.isLoading=false;
            if(error.response.status==400){
              switch(error.response.data.tipo){
                case('NOCUMPLE'):
                this.$store.commit('SET_MOSTRAR_YA_REGISTRADO',false);
                  this.$store.commit('SET_MOSTRAR_DESAFIO_EXCLUSIVO',true);
                break;
                case('FINALIZADO'):
                this.$store.commit('SET_MOSTRAR_YA_REGISTRADO',false);
                  this.$store.commit('SET_MOSTRAR_FINALIZADO',true);
                break;
                case('AGOTADO'):
                this.$store.commit('SET_MOSTRAR_YA_REGISTRADO',false);
                  this.$store.commit('SET_MOSTRAR_OPPS',true);
                break;
                case('INSCRITO'):
                this.$store.commit('SET_MOSTRAR_YA_REGISTRADO',false);
                  this.$store.commit('SET_MOSTRAR_YA_REGISTRADO',true);
                break;
                case('NOINSCRITO'):
                this.$store.commit('SET_MOSTRAR_YA_REGISTRADO',false);
                  this.$store.commit('SET_MOSTRAR_NOREGISTRADO',true);
                break;
              }
            }
          })
      },
    },
  created(){
    window.scrollTo(0,0);
  },
    
}
</script>

<style>


/* Estilos para pantallas más grandes (por ejemplo, PCs) */
@media (min-width: 768px) {
  .contimg {
  display: flex;
  width: 100%; /* El div ocupa el 100% del ancho de la pantalla */
  align-items: left;
}


.imagens {
  width: 20%; /* La imagen ocupa el 20% del ancho del div */
  margin-top: 2%; /* Margen superior en dispositivos móviles */
  margin-left: 10%;
}

.contimg2 {
  display: flex;
  width: 100%;
  position: relative;
  margin-top: -10%;

}

.imagens2 {
  width: 100%;
}

.curadradoRojo{
  background-color: #d7332a; /* Fondo rojo */
  padding: 10px;

}
.texto-derecha {
  position: absolute;
  top: 50%;
  right: 5%;
  color: white; /* Texto en blanco */
  transform: translateY(-50%);
  text-align: center;
  font-size: 40px; /* Establece el tamaño de fuente solo para el segundo label */
  padding: 10px;
}

.texto-derecha label {
  font-weight: bold; /* Hace que todos los labels sean negrita */
  color: white; /* Texto en blanco */
  margin: auto;
  padding: auto;
}


.texto-derecha br {
  margin: 0%;
  padding: 0%;

}
.masFont {
  font-size: 150px; /* Establece el tamaño de fuente solo para el segundo label */
  color: white; /* Texto en blanco */
  margin: auto;
  padding: auto;

}

.texto-center {
  text-align: center;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 1%;
}

.texto-white {
  color: #FFFFFF;
  font-family: 'Gotham', sans-serif;
  font-weight: lighter; /* Texto ligero */
  font-size: 18px;
}

.texto-bold {
  font-weight: bold;
  font-size: 24px;
  color: #FFFFFF;

}

.texto-rojo {
  background-color: #d7332a;
  color: white; /* Color de texto blanco */
  padding: 5px 10px; /* Espaciado interno */
  border-radius: 4px; /* Bordes redondeados */
}

.textMobile {
  font-size: 26px !important;
}

}

/* Estilos para pantallas más pequeñas (por ejemplo, dispositivos móviles) */
@media (max-width: 767px) {
  .texto-derecha-mobile {
    font-size: 8px !important;
  }
  .btn-ver{
    width: 100%!important;
    padding: 2%!important;
    margin: 2%!important;
    margin-top: 4%!important;
    margin-bottom: 4%!important;

  }


  .textMobile {
    font-size: 22px !important;
}


  .contimg {
  width: 100%; /* El div ocupa el 100% del ancho de la pantalla */
  align-items: center;
  text-align: center;
}
  .imagens {
    width: 80%; /* Porcentaje de ancho para dispositivos móviles */

  }
  .contimg2 {
    display: flex;
    width: 100%;
    position: relative;
  }

  .imagens2 {
    width: 100%;
  }

  .curadradoRojo {
    background-color: #d7332a;
    padding: 10px;
  }

  .texto-derecha {
    position: absolute;
    top: 50%;
    right: 5%;
    color: white;
    transform: translateY(-50%);
    text-align: center;
    font-size: 15px;
    padding: 10px;
  }

  .texto-derecha label {
    font-weight: bold;
    color: white;
    margin: auto;
    padding: auto;
  }

  .texto-derecha br {
    margin: 0;
    padding: 0;
  }

  .masFont {
    font-size: 20px;
    color: white;
    margin: auto;
    padding: auto;
  }

  .texto-center {
    text-align: center;
    margin-left: 10%;
    margin-right: 10%;
    margin-top: 1%;
  }

  .texto-white {
    color: #FFFFFF;
    font-family: 'Gotham', sans-serif;
    font-weight: lighter;
    font-size: 18px;
  }

  .texto-bold {
    font-weight: bold;
    font-size: 24px;
    color: #FFFFFF;
  }

  .texto-rojo {
    background-color: #d7332a;
    color: white;
    padding: 5px 10px;
    border-radius: 4px;
  }
}
</style>